/*!
    * @product/scmp-sdk 1.1.39
    * built by undefined
  */
function n(){if(!(typeof window>"u"))return window}export{n as a};
//# sourceMappingURL=chunk-2ADP3XOJ.js.map
